import Web3Status from 'components/Web3Status'
import { CHAIN_INFO } from 'constants/chainInfo'
import { SupportedChainId } from 'constants/chains'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useState } from 'react'

import { NavLink } from 'react-router-dom'

import { useNativeCurrencyBalances } from 'state/wallet/hooks'
import styled from 'styled-components/macro'
// import NetworkSelector from './NetworkSelector'

const HeaderElement = styled.div``

const AccountElement = styled.div<{ active: boolean }>``

const activeClassName = 'ACTIVE'

export default function Header() {
  const { account, chainId } = useActiveWeb3React()

  const userEthBalance = useNativeCurrencyBalances(account ? [account] : [])?.[account ?? '']
  const [mobile, setMobile] = useState(false)

  const {
    infoLink,
    nativeCurrency: { symbol: nativeCurrencySymbol },
  } = CHAIN_INFO[chainId ? chainId : SupportedChainId.MAINNET]

  return (
    <nav className="navbar navbar-expand-lg fixed-top center-brand static-nav   " style={{ backgroundColor: 'black' }}>
      <div className="container-fluid d-flex align-content-center justify-content-between">
        <NavLink className="navbar-brand" to="/">
          <img src="img/logo.png" alt="logo" className="logo-custom" />
        </NavLink>
        <ul
          className={
            !mobile
              ? 'navbar-1 align-items-sm-center  d-none d-sm-flex '
              : 'navbar-1 align-items-sm-center  d-sm-flex header__top-nav'
          }
        >
          <li className="nav-item">
            <NavLink className="nav-link" to="buy" onClick={() => setMobile(false)}>
              BUY MIC
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to={'referral'} className="nav-link" onClick={() => setMobile(false)}>
              REFERRAL
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink to={'faq'} className="nav-link" onClick={() => setMobile(false)}>
              FAQ
            </NavLink>
          </li>
          {/* <NetworkSelector /> */}
          <Web3Status />
        </ul>
        <div onClick={() => setMobile(!mobile)} className="menu dots d-sm-none d-inline" />
      </div>
    </nav>
  )
}
